/*
 * Card da versão curva (snippets/plenty-card.liquid, modelo C1)
 * - Sacola: abre os tamanhos (ou adiciona direto se o produto não tem tamanho).
 * - Tamanho: adiciona à sacola pelo /cart/add.js, avisa o tema (cart:update) e abre a sacola.
 * - Bolinhas: trocam fotos, link, preço, nome da cor e tamanhos para a outra cor, sem sair da página.
 * - Fotos: arrastar troca a foto nas grades ([data-pcc-swipe]); tocar no indicador troca em qualquer lugar;
 *   no desktop, passar o mouse mostra a 2ª foto. O 1º card de grade que aparece na tela dá uma mexida, uma vez.
 * Delegação no document: funciona em cards que chegam depois (filtros, "ver mais").
 */
(function () {
  if (window.__plentyCard) return;
  window.__plentyCard = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function closeAll(except) {
    document.querySelectorAll('.pcc.is-sz').forEach(function (c) {
      if (c !== except) setSizes(c, false);
    });
  }

  function setSizes(card, on) {
    card.classList.toggle('is-sz', on);
    var qa = card.querySelector('[data-pcc-qa]');
    if (qa) qa.setAttribute('aria-expanded', on ? 'true' : 'false');
    card.querySelectorAll('[data-pcc-sizes] button').forEach(function (b) {
      b.tabIndex = on ? 0 : -1;
    });
    if (on) {
      var first = card.querySelector('[data-pcc-sizes] button:not(:disabled)');
      if (first && card.contains(document.activeElement)) first.focus({ preventScroll: true });
    }
  }

  function msg(card, text) {
    var old = card.querySelector('.pcc__msg');
    if (old) old.remove();
    if (!text) return;
    var m = document.createElement('p');
    m.className = 'pcc__msg';
    m.setAttribute('role', 'status');
    m.textContent = text;
    card.querySelector('.pcc__media').appendChild(m);
    setTimeout(function () { m.remove(); }, 2600);
  }

  /* sacola: uma função só, usada pelo card e pela página de produto (window.PlentyCart.add) */
  function cartAdd(id, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      })
      .then(function () {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: cart,
          sourceId: 'plenty',
          data: { itemCount: cart.item_count, source: 'plenty', variantId: String(id), sections: {} }
        };
        document.dispatchEvent(ev);
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') {
          setTimeout(function () { drawer.open(); }, 250);
        }
        return cart;
      });
  }
  window.PlentyCart = { add: cartAdd };

  function add(card, id, btn) {
    if (card.__busy) return;
    card.__busy = true;
    if (btn) btn.classList.add('is-busy');
    cartAdd(id, 1)
      .then(function () {
        setSizes(card, false);
        card.classList.add('is-ok');
        setTimeout(function () { card.classList.remove('is-ok'); }, 1400);
      })
      .catch(function (e) {
        msg(card, (e && (e.description || e.message)) || 'Não deu para adicionar. Tente de novo.');
      })
      .finally(function () {
        card.__busy = false;
        if (btn) btn.classList.remove('is-busy');
      });
  }

  function variantsOf(card) {
    if (card.__variants) return card.__variants;
    var s = card.querySelector('[data-pcc-json]');
    try {
      card.__variants = JSON.parse(s.textContent).variants;
    } catch (e) {
      card.__variants = [];
    }
    return card.__variants;
  }

  function renderSizes(card, variants) {
    card.__variants = variants;
    var box = card.querySelector('[data-pcc-sizes]');
    var single = variants.length === 1 && /default/i.test(variants[0].t);
    card.dataset.single = single ? 'true' : 'false';
    if (!box) return;
    box.innerHTML = '';
    variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.id = v.id;
      b.textContent = v.t;
      b.tabIndex = -1;
      if (!v.a) b.disabled = true;
      box.appendChild(b);
    });
  }

  /* ---------- fotos ---------- */
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mediaOf(card) { return card.querySelector('.pcc__media'); }
  /* fotos 2..5 do card só baixam quando a pessoa encosta nele (toque, mouse por cima, indicador) */
  function wake(m) {
    if (!m || m.__woke) return;
    m.__woke = true;
    m.querySelectorAll('img[data-pcc-later]').forEach(function (im) {
      if (im.dataset.srcset) im.srcset = im.dataset.srcset;
      if (im.dataset.src) im.src = im.dataset.src;
      im.removeAttribute('data-pcc-later');
    });
  }
  ['pointerdown', 'touchstart', 'pointerover', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var m = e.target.closest && e.target.closest('.pcc__media');
      if (m) wake(m);
    }, { passive: true, capture: true });
  });
  function goTo(card, k) {
    var m = mediaOf(card);
    wake(m);
    var n = +m.dataset.n || 1;
    var i = Math.max(0, Math.min(n - 1, k));
    m.__i = i;
    var t = m.querySelector('[data-pcc-track]');
    if (t) t.style.transform = i ? 'translateX(' + (-i * 100) + '%)' : '';
    m.querySelectorAll('[data-pcc-go]').forEach(function (b, j) { b.classList.toggle('is-on', j === i); });
  }

  function pickColor(card, dot) {
    var label = card.querySelector('[data-pcc-swl]');
    if (dot.classList.contains('is-on')) return;
    card.querySelectorAll('[data-pcc-dot]').forEach(function (d) {
      var on = d === dot;
      d.classList.toggle('is-on', on);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (label) {
      if (reduce) label.textContent = dot.dataset.name;
      else {
        label.classList.add('is-out');
        setTimeout(function () { label.textContent = dot.dataset.name; label.classList.remove('is-out'); }, 170);
      }
    }
    var imgs = [];
    try { imgs = JSON.parse(dot.dataset.imgs || '[]'); } catch (e) {}
    var m = mediaOf(card);
    var track = m.querySelector('[data-pcc-track]');
    if (track && imgs.length) {
      card.classList.add('is-loading');
      var first = new Image();
      first.onload = first.onerror = function () {
        track.innerHTML = imgs.map(function (u, i) {
          return '<img src="' + u + '" alt="' + (i ? '' : (dot.dataset.title || '').replace(/"/g, '&quot;')) + '" draggable="false"' + (i ? ' loading="lazy"' : '') + '>';
        }).join('');
        m.dataset.n = imgs.length;
        var ind = m.querySelector('[data-pcc-ind]');
        if (ind) {
          ind.innerHTML = imgs.map(function (u, i) { return '<button type="button" data-pcc-go="' + i + '" aria-label="Foto ' + (i + 1) + ' de ' + imgs.length + '" tabindex="-1"></button>'; }).join('');
          ind.hidden = imgs.length < 2;
        }
        goTo(card, 0);
        card.classList.remove('is-loading');
      };
      first.src = imgs[0];
    }
    card.querySelectorAll('[data-pcc-link]').forEach(function (l) { l.href = dot.dataset.url; });
    var price = card.querySelector('[data-pcc-price]');
    if (price && dot.dataset.price) price.innerHTML = dot.dataset.price;
    var qa = card.querySelector('[data-pcc-qa]');
    if (qa) qa.setAttribute('aria-label', 'Adicionar ' + dot.dataset.title + ' à sacola');
    try {
      renderSizes(card, JSON.parse(dot.dataset.variants));
    } catch (e) {}
    var avail = dot.dataset.avail === 'true';
    card.classList.toggle('is-out', !avail);
    if (qa) qa.hidden = !avail;
    setSizes(card, false);
  }

  /* arrastar a foto (só nas grades) */
  var drag = null;
  /* área segura: só o centro da foto troca a foto (mesma medida do .pcc__zone no CSS). Bordas laterais (15% de
     cada lado) e as faixas de cima (selo) e de baixo (indicador e sacola) não trocam; numa fileira, ali o celular rola a fileira. */
  var ZONE = { x: 0.15, top: 0.12, bottom: 0.18 };
  function inZone(m, x, y) {
    var r = m.getBoundingClientRect();
    var fx = (x - r.left) / r.width, fy = (y - r.top) / r.height;
    return fx >= ZONE.x && fx <= 1 - ZONE.x && fy >= ZONE.top && fy <= 1 - ZONE.bottom;
  }
  document.addEventListener('pointerdown', function (e) {
    var m = e.target.closest && e.target.closest('[data-pcc-swipe]');
    if (!m || e.button > 0 || e.target.closest('button, [data-pcc-sizes]') || (+m.dataset.n || 1) < 2) return;
    /* fora do centro o card não faz nada: numa fileira, o próprio celular rola a fileira (com embalo) */
    if (!inZone(m, e.clientX, e.clientY)) return;
    drag = { m: m, x: e.clientX, y: e.clientY, dx: 0, lock: null, w: m.clientWidth, id: e.pointerId, t: Date.now() };
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (drag.lock === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
      drag.lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      /* dentro de uma fileira que rola (Combina com): passou da 1ª/última foto → quem anda é a fileira */
      var i0 = drag.m.__i || 0, n0 = +drag.m.dataset.n, row = drag.m.closest('[data-pcc-row]');
      if (drag.lock === 'x' && row && row.scrollWidth > row.clientWidth + 2 && ((i0 === 0 && dx > 0) || (i0 === n0 - 1 && dx < 0))) {
        drag.lock = 'row'; drag.row = row; drag.sl = row.scrollLeft; row.style.scrollSnapType = 'none';
      }
      if (drag.lock === 'x') drag.m.classList.add('is-drag');
    }
    if (drag.lock === 'row') { drag.dx = dx; drag.row.scrollLeft = drag.sl - dx; return; }
    if (drag.lock !== 'x') return;
    drag.dx = dx;
    var i = drag.m.__i || 0, n = +drag.m.dataset.n;
    var edge = (i === 0 && dx > 0) || (i === n - 1 && dx < 0) ? 0.35 : 1;
    var t = drag.m.querySelector('[data-pcc-track]');
    t.style.transform = 'translateX(calc(' + (-i * 100) + '% + ' + (dx * edge) + 'px))';
  }, { passive: true });
  function endDrag() {
    if (!drag) return;
    var d = drag;
    drag = null;
    d.m.classList.remove('is-drag');
    if (d.lock === 'row') {
      var r = d.row, cs = r.children, x0 = cs[0].offsetLeft;
      var near = function (x) { var k = 0, bd = Infinity; for (var j = 0; j < cs.length; j++) { var dd = Math.abs(cs[j].offsetLeft - x0 - x); if (dd < bd) { bd = dd; k = j; } } return k; };
      var from = near(d.sl), best = near(r.scrollLeft);
      var fast = Math.abs(d.dx) / Math.max(1, Date.now() - d.t) > 0.3;
      if (best === from && (Math.abs(d.dx) > 30 || fast)) best += d.dx < 0 ? 1 : -1;
      best = Math.max(0, Math.min(cs.length - 1, best));
      r.scrollTo({ left: cs[best].offsetLeft - x0, behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function () { r.style.scrollSnapType = ''; }, 450);
      d.m.__dragged = Date.now();
      return;
    }
    if (d.lock !== 'x') return;
    var i = d.m.__i || 0, th = d.w * 0.18;
    goTo(d.m.closest('[data-pcc]'), d.dx < -th ? i + 1 : d.dx > th ? i - 1 : i);
    /* o toque que arrastou não abre o produto */
    d.m.__dragged = Date.now();
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  document.addEventListener('click', function (e) {
    var m = e.target.closest && e.target.closest('[data-pcc-swipe]');
    if (m && m.__dragged && Date.now() - m.__dragged < 400) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* desktop: passar o mouse mostra a 2ª foto */
  if (window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('pointerover', function (e) {
      var m = e.target.closest && e.target.closest('.pcc__media');
      if (!m || m.__hov || (+m.dataset.n || 1) < 2 || m.contains(e.relatedTarget)) return;
      m.__hov = true;
      if (!(m.__i > 0)) { goTo(m.closest('[data-pcc]'), 1); m.__auto = true; }
    });
    document.addEventListener('pointerout', function (e) {
      var m = e.target.closest && e.target.closest('.pcc__media');
      if (!m || m.contains(e.relatedTarget)) return;
      m.__hov = false;
      if (m.__auto) { goTo(m.closest('[data-pcc]'), 0); m.__auto = false; }
    });
  }

  /* dica: o 1º card de grade que aparece na tela dá uma mexida e volta, uma vez por página */
  var nudged = false;
  function nudge(m) {
    if (nudged || reduce) return;
    nudged = true;
    var t = m.querySelector('[data-pcc-track]');
    if (!t || !t.animate) return;
    wake(m);
    t.animate([
      { transform: 'translateX(0)' },
      { transform: 'translateX(-16%)', offset: 0.42 },
      { transform: 'translateX(-16%)', offset: 0.55 },
      { transform: 'translateX(0)' }
    ], { duration: 1100, easing: 'cubic-bezier(.22,1,.36,1)' });
    var b = m.querySelectorAll('[data-pcc-go]')[1];
    if (b && b.animate) b.animate([{ width: '4px' }, { width: '7px', offset: 0.45 }, { width: '4px' }], { duration: 1100, easing: 'ease' });
  }
  function armNudge() {
    if (nudged || reduce || !('IntersectionObserver' in window)) return;
    var first = document.querySelector('[data-pcc-swipe]:not([data-n="0"]):not([data-n="1"])');
    if (!first || first.__armed) return;
    first.__armed = true;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting && en.intersectionRatio > 0.6) {
          io.disconnect();
          setTimeout(function () { nudge(first); }, 700);
        }
      });
    }, { threshold: [0, 0.6, 1] });
    io.observe(first);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armNudge);
  else armNudge();
  /* cards que chegam depois (busca do menu, filtros): tenta de novo */
  var moT = null;
  var mo = new MutationObserver(function () {
    if (nudged) { mo.disconnect(); return; }
    clearTimeout(moT);
    moT = setTimeout(armNudge, 250);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var qa = t.closest && t.closest('[data-pcc-qa]');
    var sz = t.closest && t.closest('[data-pcc-sizes] button');
    var dot = t.closest && t.closest('[data-pcc-dot]');
    var go = t.closest && t.closest('[data-pcc-go]');
    if (go) {
      e.preventDefault();
      goTo(go.closest('[data-pcc]'), +go.dataset.pccGo);
      var gm = go.closest('.pcc__media');
      if (gm) gm.__auto = false;
      return;
    }
    if (qa) {
      var card = qa.closest('[data-pcc]');
      e.preventDefault();
      var vs = variantsOf(card);
      if (card.dataset.single === 'true' && vs[0]) {
        add(card, vs[0].id, null);
        return;
      }
      closeAll(card);
      setSizes(card, !card.classList.contains('is-sz'));
      return;
    }
    if (sz) {
      e.preventDefault();
      if (!sz.disabled) add(sz.closest('[data-pcc]'), sz.dataset.id, sz);
      return;
    }
    if (dot) {
      e.preventDefault();
      pickColor(dot.closest('[data-pcc]'), dot);
      return;
    }
    if (!(t.closest && t.closest('.pcc.is-sz'))) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.pcc.is-sz');
    if (!open) return;
    setSizes(open, false);
    var qa = open.querySelector('[data-pcc-qa]');
    if (qa) qa.focus();
  });
})();
